// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import * as hyCommon from '@huaying/hy-vue-common'
import App from './App'

// styles
import '@huaying/hy-vue-common/dist/hycommon.css'

import router from './router'
import * as routes from './routes'
import store from './store'

import requestFactory from '@huaying/hy-vue-common/src/lib/request'

import protoRoot from './proto/proto'

import toastMixin from './mixins/toast'
import backMixin from './mixins/back'
import installCommonComponents from './utils/components'

import { registerMappers, registerFilters } from './filter'
import createMappersFromEnums from './utils/mapper'
import { envOverride } from './utils/envOverride'
import scrollSpy from 'vue2-scrollspy'

Vue.use(scrollSpy)

hyCommon.install(Vue, protoRoot, store, router, routes, null, {
  env: envOverride
})

Vue.config.productionTip = false

registerFilters(Vue)

installCommonComponents(Vue)
Vue.fwRequest = requestFactory(protoRoot, null, '/fwApi')
Vue.ltRequest = requestFactory(protoRoot, null, '/ltApi')
Vue.eGameRequest = requestFactory(protoRoot, null, '/eGameApi')

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})

Vue.mixin(toastMixin)
Vue.mixin(backMixin)

const mappers = createMappersFromEnums(Vue.enums, app.$proto.nested)
registerMappers(mappers)

export default Vue
export const mapper = mappers
export const request = Vue.request
export const proto = Vue.proto
export const enums = Vue.enums
export const fwRequest = Vue.fwRequest
export const ltRequest = Vue.ltRequest
export const eGameRequest = Vue.eGameRequest



// WEBPACK FOOTER //
// ./src/main.js